import * as React from "react";
import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import Divider from "@mui/material/Divider";
import { Button as PrimeButton } from "primereact/button";
import { Dialog } from "primereact/dialog";
import ToolTip from "../common/ToolTip";
import { ICONS } from "../../constants/icons";
import { GoogleMaterialIcon } from "../ui/GoogleMaterialIcon";
import { useCommonDetailsContext } from "../../context/Common/common";
import { tokens } from "../../theme/tokens";


export default function PostAwardApprovalConfigToolbox(props: {
    displayHistory: () => void;
}) {
    const { publishedBranding } = useCommonDetailsContext();
    const primaryColor =
        publishedBranding?.primaryColor || tokens.colors.connectedPurple;
    const navigate = useNavigate();
    const [alertMessage, setAlertMessage] = React.useState("");
    const [showAlert, setShowAlert] = React.useState(false);

    const displayHistory = () => {
        props.displayHistory()
    };

    const showTrackerPage = () => {
        navigate("/client-filing-tracker-list");
    };

    const showFilingApproval = () => {
        navigate("/filing-master-list");
    };

    const showClientApproval = () => {
        navigate("/postaward-filing-master-list");
    };
    
    const footerContent = (
        <div>
            <PrimeButton
                label="OK"
                icon="pi pi-check"
                onClick={() => closeAlert()}
                autoFocus
            />
        </div>
    );

    const closeAlert = () => {
        setShowAlert(false);
    };
    return (
        <React.Fragment>
            <Dialog
                header="Info"
                visible={showAlert}
                style={{ width: "30vw" }}
                onHide={() => closeAlert()}
                footer={footerContent}
            >
                <p className="m-0">{alertMessage}</p>
            </Dialog>

            <Box sx={{ width: "100%", maxWidth: 360, bgcolor: "#fff", borderRadius: "50px !important", padding: "16px 8px" }}>
                <nav aria-label="main mailbox folders">
                    <List>
                        <ListItem disablePadding sx={{ justifyContent: "center" }}>
                            <ToolTip title="">
                                <ListItemButton sx={{ justifyContent: "center" }}>
                                    <ListItemIcon sx={{ minWidth: "auto", color: primaryColor }}>
                                        <GoogleMaterialIcon name={ICONS.filter_list} size={24} color={primaryColor} />
                                    </ListItemIcon>
                                </ListItemButton>
                            </ToolTip>
                        </ListItem>
                        <ListItem disablePadding sx={{ justifyContent: "center" }}>
                            <ToolTip title="TrackNow Filing Master">
                                <ListItemButton
                                onClick={showClientApproval}
                                sx={{ justifyContent: "center" }}
                                >
                                    <ListItemIcon sx={{ minWidth: "auto", color: primaryColor }}>
                                        <GoogleMaterialIcon name={ICONS.list} size={24} color={primaryColor} />
                                    </ListItemIcon>
                                </ListItemButton>
                            </ToolTip>
                        </ListItem>
                    </List>
                </nav>
                <Divider sx={{ borderColor: primaryColor, width: "80%", margin: "0 auto" }} />
                <nav aria-label="secondary mailbox folders">
                    <List>
                        <ListItem disablePadding sx={{ justifyContent: "center" }}>
                            <ToolTip title="PostAward Filing Master">
                                <ListItemButton
                                onClick={showFilingApproval}
                                sx={{ justifyContent: "center" }}
                                >
                                    <ListItemIcon sx={{ minWidth: "auto", color: primaryColor }}>
                                        <GoogleMaterialIcon name={ICONS.view_list} size={24} color={primaryColor} />
                                    </ListItemIcon>
                                </ListItemButton>
                            </ToolTip>
                        </ListItem>
                        <ListItem disablePadding sx={{ justifyContent: "center" }}>
                            <ToolTip title="Activity History">
                                <ListItemButton
                                    onClick={displayHistory}
                                sx={{ justifyContent: "center" }}
                                >
                                    <ListItemIcon sx={{ minWidth: "auto", color: primaryColor }}>
                                        <GoogleMaterialIcon name={ICONS.history} size={24} color={primaryColor} />
                                    </ListItemIcon>
                                </ListItemButton>
                            </ToolTip>
                        </ListItem>
                    </List>
                </nav>
            </Box>
        </React.Fragment>
    );
}
